import {
  Alert,
  AlertIcon,
  AlertDescription,
  Text,
  Link,
} from "@chakra-ui/react";
import { Link as RemixLink } from "@remix-run/react";

export function EmailBounceBanner(props) {
  return (
    <Alert status="error" variant="solid" {...props}>
      <AlertIcon />
      <AlertDescription>
        <Text>
          We couldn't deliver emails to your address. Your requests have been
          paused.{" "}
          <Link
            as={RemixLink}
            to="/account"
            fontWeight="bold"
            textDecoration="underline"
            color="inverted"
          >
            Update your email
          </Link>{" "}
          to resume watching.
        </Text>
      </AlertDescription>
    </Alert>
  );
}
